import { cva } from 'class-variance-authority';

export const timePickerVariants = cva('w-full transition-colors duration-200 ease-in-out', {
  variants: {
    intent: {
      filled:
        'ant-input-filled bg-slate-200/50 text-inputTextDefault border border-inputActiveBorder hover:border-inputFocusBorder focus:border-btnLightFilledHover focus:border-2 gap-2',
      outlined:
        'ant-input-outlined bg-transparent text-inputTextDefault border border-inputActiveBorder hover:border-inputFocusBorder focus:border-btnFilledHover focus:border-2 gap-2',
    },
    size: {
      small: 'h-8 text-sm ps-2 pe-1',
      middle: 'h-10 text-base ps-3 pe-1',
      large: 'h-12 text-lg ps-4 pe-1',
    },
    error: {
      true: '!border-error-main-filled',
      false: 'focus:border-inputFocusBorder !border-inputActiveBorder',
    },
  },
  defaultVariants: {
    intent: 'outlined',
    size: 'middle',
  },
});
